import store from '@/store/index'
import { refreshTokenVerify } from '@/api/auth'
import { saveTokenToStorage } from '@/utils/storages'

let hasShownLogoutAlert = false

export function setInterceptors(instance) {
  // Add a request interceptor
  instance.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      // console.log(config);
      // store.commit('START_SPINNER');

      const token = store.state.userToken
      config.headers.Authorization = store.state.userToken
      return config
    },
    function (error) {
      // Do something with request error
      // store.commit('END_SPINNER');
      return Promise.reject(error)
    }
  )

  // Add a response interceptor
  instance.interceptors.response.use(
    // function (response) {
    //   // store.commit('END_SPINNER');
    //   return response
    // },
    async function (response) {
      // response 유효성 확인
      if (!response || !response.status) {
        console.error('Invalid response:', response)
        // alert(`Invalid response: ${JSON.stringify(response, null, 2)}`); // alert로 response 출력
        return Promise.reject(new Error('Invalid response'))
      }

      // 203 상태 코드 처리
      if (response.status === 203) {
        try {
          // 토큰 재발급 로직
          const res = await refreshTokenVerify()
          // res 유효성 확인
          if (!res || !res.status) {
            console.error('Invalid response:', res)
            // alert(`Invalid res: ${JSON.stringify(res, null, 2)}`); // alert로 response 출력
            return Promise.reject(new Error('Invalid refresh token response'))
          }

          if (res.status === 200) {
            // 유저 정보 업데이트
            // store.commit('SET_USER_INFO', res.data.userInfo)
            saveTokenToStorage(res.data)
            // 원래 요청 재시도
            const originalRequest = response.config
            originalRequest.headers.Authorization =
              store.state.userInfo.userToken
            return instance(originalRequest)
          } else if (res.status === 203) {
            // 토큰 갱신 실패
            if (!hasShownLogoutAlert) {
              hasShownLogoutAlert = true
              alert('로그인이 만료되었습니다.')
              await store.dispatch('LOGOUT')
              hasShownLogoutAlert = false // 로그아웃 후 초기화
            }
            // return Promise.reject(new Error('세션 만료'));
            // alert('로그인이 만료되었습니다.')
            // await store.dispatch('LOGOUT')
            // return Promise.reject('세션 만료')
          }
        } catch (error) {
          console.error('토큰 갱신 실패:', error)
          // alert(`interceptorError: ${JSON.stringify(error, Object.getOwnPropertyNames(error))}`)
          return Promise.reject(error)
        }
      }
      return response
    },
    function (error) {
      // store.commit('END_SPINNER');
      return Promise.reject(error)
    }
  )
  return instance
}
